// pages/ProtectedLayout.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PageLayout from "./PageLayout";

// importér ALLE sider her (samme som før i AppRoutes)
import { AccountPage } from "pages/Account/AccountPage";
import { BillingDetail, BillingView } from "pages/Billing";
import { Billed } from "pages/Billing/Billed";
import { Agreements } from "pages/Companies/Agreements";
import { Companies } from "pages/Companies/Companies";
import { CompaniesList } from "pages/Companies/CompaniesList";
import { Company } from "pages/Companies/Company";
import { CompanyDetails } from "pages/Companies/CompanyDetails";
import { CompanyFinance } from "pages/Companies/CompanyFinance";
import { CompanyProducts } from "pages/Companies/CompanyProducts";
import { CompanyTickets } from "pages/Companies/CompanyTickets";
import { Department } from "pages/Companies/Department";
import { Departments } from "pages/Companies/Departments";
import { Employees } from "pages/Companies/Employees";
import { Package } from "pages/Companies/Package";
import { Packages } from "pages/Companies/Packages";
import { Resource } from "pages/Companies/Resource";
import { Resources } from "pages/Companies/Resources";
import Dashboard from "pages/Dashboard/Dashboard";
import { Feedbacks } from "pages/Feedback";
import Finance from "pages/Finance/Finance";
import { Marketing } from "pages/Marketing/Marketing";
import { CloudFactory } from "pages/Modules/CloudFactory/CloudFactory";
import { ModuleList } from "pages/Modules/ModuleList";
import { OrderDetail } from "pages/Orders/OrderDetail";
import { Ordered } from "pages/Orders/Ordered";
import { OrderFinance } from "pages/Orders/OrderFinance";
import { OrderHistory } from "pages/Orders/OrderHistory";
import { OrderPosts } from "pages/Orders/OrderPosts";
import { ProductForm, Products } from "pages/Products";
import { AppValues } from "pages/Setup/AppValues";
import { AutoAnswers } from "pages/Setup/AutoAnswers";
import { Brand } from "pages/Setup/Brand";
import { Budget } from "pages/Setup/Budget";
import { DefaultSettings } from "pages/Setup/DefaultSettings";
import { MainCompany } from "pages/Setup/MainCompany";
import { MainEmployees } from "pages/Setup/MainEmployees";
import { Setup } from "pages/Setup/Setup";
import { WorkRoles } from "pages/Setup/WorkRoles";
import { Storage, StorageView } from "pages/Storage";
import { Test } from "pages/Test";
import {
  NewTicket,
  SelectedTicketMerge,
  Ticket,
  TicketAttachments,
  TicketCommunications,
  TicketDetails,
  TicketEconomy,
  TicketMerge,
  TicketProductsHistory,
  TicketResolution,
  Tickets,
  TicketsList,
} from "pages/Tickets";
import News from "./news/news";
import LoginErrorPage from "./Landing/LoginErrorPage";

const ProtectedLayout: React.FC = () => {
  return (
    <Routes>
      {/* Layout wrapper */}
      <Route element={<PageLayout />}>
       {/* error route */}
       <Route path="/login-error" element={<LoginErrorPage />} />
        {/* default route */}
        <Route index element={<Navigate to="news" replace />} />
        <Route path="news" element={<News />} />

        <Route path="test" element={<Test />} />
        <Route path="accountPage" element={<AccountPage />} />

        <Route path="BillingView" element={<BillingDetail />}>
          <Route index element={<BillingView />} />
        </Route>

        <Route path="billing/ordersList" element={<BillingDetail />}>
          <Route index element={<Billed />} />
        </Route>

        <Route path="dashboard" element={<Dashboard />} />

        <Route path="companies" element={<Companies />}>
          <Route index element={<CompaniesList />} />
          <Route path=":companyId" element={<Company />}>
            <Route index element={<CompanyDetails />} />
            <Route path="departments" element={<Departments />}>
              <Route path=":departmentId" element={<Department />} />
            </Route>
            <Route path="resources" element={<Resources />}>
              <Route path=":resourceId" element={<Resource />} />
            </Route>
            <Route path="employees" element={<Employees />}>
              <Route path=":employeeId" element={<Employees />} />
            </Route>
            <Route path="packages" element={<Packages />}>
              <Route path=":packageId" element={<Package />} />
            </Route>
            <Route path="products" element={<CompanyProducts />} />
            <Route path="tickets" element={<CompanyTickets />} />
            <Route path="agreements" element={<Agreements />} />
            <Route path="finance" element={<CompanyFinance />} />
          </Route>
        </Route>

        <Route path="tickets" element={<Tickets />}>
          <Route index element={<TicketsList />} />
          <Route path="new" element={<NewTicket />} />
          <Route path=":ticketId" element={<Ticket />}>
            <Route index element={<TicketDetails />} />
            <Route path="communications" element={<TicketCommunications />} />
            <Route path="productsHistory" element={<TicketProductsHistory />} />
            <Route path="economy" element={<TicketEconomy />} />
            <Route path="resolution" element={<TicketResolution />} />
            <Route path="attachments" element={<TicketAttachments />} />
            <Route path="merge" element={<TicketMerge />}>
              <Route path=":selectedTicketId" element={<SelectedTicketMerge />} />
            </Route>
          </Route>
        </Route>

        <Route path="orders" element={<OrderDetail />}>
          <Route index element={<OrderPosts />} />
          <Route path="ordered" element={<Ordered />} />
          <Route path="orderHistory" element={<OrderHistory />} />
          <Route path="finance" element={<OrderFinance />} />
        </Route>

        <Route path="Storage" element={<Storage />}>
          <Route index element={<StorageView />} />
          <Route path=":productId" element={<ProductForm />} />
        </Route>

        <Route path="products" element={<Products />}>
          <Route path=":productId" element={<ProductForm />} />
        </Route>

        <Route path="marketing" element={<Marketing />} />
        <Route path="finance" element={<Finance />} />

        <Route path="setup" element={<Setup />}>
          <Route index element={<MainCompany />} />
          <Route path="mainCompany" element={<MainCompany />} />
          <Route path="employees" element={<MainEmployees />} />
          <Route path="autoAnswers" element={<AutoAnswers />} />
          <Route path="appValues" element={<AppValues />} />
          <Route path="workRoles" element={<WorkRoles />} />
          <Route path="brand" element={<Brand />} />
          <Route path="defaultSettings" element={<DefaultSettings />} />
          <Route path="budget" element={<Budget />} />
        </Route>

        <Route path="feedback" element={<Feedbacks />} />
        <Route path="modules" element={<ModuleList />} />
        <Route path="cloudFactory" element={<CloudFactory />} />

        {/* catch all */}
        <Route path="*" element={<div></div>} />
      </Route>
    </Routes>
  );
};

export default ProtectedLayout;
